module.exports = __webpack_public_path__ + "img/hero_portrait_demon-hunter_male.04e5e707.png";